import script from "./newsletter-popup.vue?vue&type=script&lang=js"
export * from "./newsletter-popup.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__